import styled from "styled-components";
import { Paragraph } from "BaseComponents/Text";

export const PagePuffText = styled(Paragraph)`
	max-width: 530px;
`;
